import React, { FC } from "react";
import { Property } from "./Property";
import { IProperty } from "./types";

interface Props {
  className?: string;
  properties: IProperty[];
}

export const PropertiesCard: FC<Props> = ({ className, properties }) => (
  <div className={className}>
    {properties.map((card) => (
      <Property
        key={`${card.label}-${card.value}`}
        className="border-b border-black-base/20 first:pt-0 last:border-none last:pb-0"
        {...card}
      />
    ))}
  </div>
);
